import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 再次购买
export function getAgain(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again',
    method: 'get',
    params
  })
}
//  再次购买列表页渲染
export function getAgainlist(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again',
    method: 'post',
    data
  })
}

// 加减
export function getDiscount(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/discount',
    method: 'get',
    params
  })
}

// 增加发货仓
export function addstore(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/addstore',
    method: 'get',
    params
  })
}

// 隐藏不可购买商品
export function latent(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/latent',
    method: 'get',
    params
  })
}
// 加入购物车
export function carts(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/shopping/carts',
    method: 'get',
    params
  })
}
// 立即购买
export function prebuys(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/prebuys',
    method: 'get',
    params
  })
}


// 删除商品信息
export function del(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again',
    method: 'delete',
    params
  })
}

// 重新设置
export function setAgain(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again',
    method: 'PUT',
    params
  })
}

// 切换仓库
export function switchStore(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/again/switch/store',
    method: 'get',
    params
  })
}



